import { Box, Typography, useMediaQuery } from '@material-ui/core';
import * as UserActions from 'store/actions/user';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LabelPrintConfigDialog from 'modules/labelPrinting/pages/catalog/products/dialogs/LabelPrintConfigDialog';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CatalogIcon from 'images/icons/objects/boxesAndPackages/Box.svg';
import PrinterIcon from 'images/icons/objects/printers/printerWhiteOutline.svg';
import ScannerIcon from 'images/icons/downloadUpload/qrCodeWhiteOutline.svg';
import { SuggestionActionButton } from '../styles';
import PrintQrCodeScannerDialog from 'modules/labelPrinting/pages/catalog/products/dialogs/PrintQrCodeScannerDialog';
import Environment from 'utils/environments';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import Axios from 'axios';

const environments = Environment(process.env.REACT_APP_ENV);

const ActionButton = ({ icon: Icon, label, onClick }) => (
  <SuggestionActionButton onClick={onClick}>
    {Icon && <img width={'25px'} src={Icon} />}
    <Typography style={{ fontWeight: 500, fontSize: 15 }}>
      {label?.toUpperCase()}
    </Typography>
  </SuggestionActionButton>
);

const SuggestionActions = ({ userInfo }) => {
  const history = useHistory();
  const { id: paramsID } = useParams();

  const isMobileScreen = useMediaQuery('(max-width: 600px)');
  const [modalSettings, setModalSettings] = useState([
    {
      id: 1,
      name: 'labelPrintConfigDialog',
      open: false,
      product: null
    },
    {
      id: 2,
      name: 'printQrCodeScannerDialog',
      open: false
    }
  ]);

  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const printLabel = async (product, isReprint = false) => {
    try {
      const response = await Axios.post(
        `${environments.catalog}/printer/products/labels`,
        {
          ...(isReprint && { labelId: product?.id }),
          restaurantId: paramsID,
          productId: isReprint ? product?.productId : product?.id,
          quantity: product?.quantity,
          numberOfLabels: product?.numberOfLabels,
          user: userInfo?.user
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      setModalSettings(
        modalSettings.map((modal) =>
          modal.name === 'labelPrintConfigDialog'
            ? { ...modal, open: false, product: null }
            : modal
        )
      );

      setMessage({
        description: 'Solicitação de impressão enviada',
        status: 'success'
      });
      return response.data;
    } catch (error) {
      setMessage({
        description: 'Erro ao imprimir etiqueta',
        status: 'error'
      });
      throw error;
    }
  };

  return (
    <Box px={2} py={3} pb={1} className="pt20">
      <Typography
        style={{
          fontSize: 16,
          fontWeight: 600,
          marginBottom: 20,
          color: '#1F2445',
          textAlign: isMobileScreen ? 'center' : 'left'
        }}
      >
        O QUE PRECISA FAZER AGORA?
      </Typography>

      <div
        className="dFlex wrap"
        style={{
          gap: 10,
          justifyContent: isMobileScreen ? 'center' : 'flex-start'
        }}
      >
        <ActionButton
          icon={CatalogIcon}
          label="Produtos"
          onClick={() =>
            history.push(`/etiquetas/catalogo/produtos/${paramsID}`)
          }
        />

        <ActionButton
          icon={PrinterIcon}
          label="Impressão"
          onClick={() =>
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'labelPrintConfigDialog'
                  ? { ...modal, open: true }
                  : modal
              )
            )
          }
        />

        <ActionButton
          icon={ScannerIcon}
          label="ESCANEAR"
          onClick={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'printQrCodeScannerDialog'
                  ? { ...modal, open: true }
                  : modal
              )
            );
          }}
        />
      </div>

      {modalSettings.find((modal) => modal.name === 'labelPrintConfigDialog')
        ?.open && (
        <LabelPrintConfigDialog
          open={
            modalSettings.find(
              (modal) => modal.name === 'labelPrintConfigDialog'
            )?.open
          }
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'labelPrintConfigDialog'
                  ? { ...modal, open: false, product: null }
                  : modal
              )
            );
          }}
          selectedProduct={
            modalSettings.find(
              (modal) => modal.name === 'labelPrintConfigDialog'
            )?.product
          }
          onSubmit={(product, isReprint) => {
            printLabel(product, isReprint);
          }}
        />
      )}

      {modalSettings.find((modal) => modal.name === 'printQrCodeScannerDialog')
        ?.open && (
        <PrintQrCodeScannerDialog
          open={
            modalSettings.find(
              (modal) => modal.name === 'printQrCodeScannerDialog'
            )?.open
          }
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'printQrCodeScannerDialog'
                  ? { ...modal, open: false, product: null }
                  : modal
              )
            );
          }}
          onDetected={async (productId) => {
            try {
              const response = await Axios.get(
                `${environments.catalog}/printer/products/${productId}`,
                {
                  params: { restaurantId: paramsID }
                }
              );

              const data = response.data;

              setModalSettings((prev) =>
                prev.map((modal) => {
                  if (modal.name === 'printQrCodeScannerDialog') {
                    return { ...modal, open: false, product: null };
                  }

                  if (modal.name === 'labelPrintConfigDialog') {
                    return { ...modal, open: true, product: data };
                  }

                  return modal;
                })
              );
            } catch (error) {
              setMessage({
                description: 'Erro ao buscar produto',
                status: 'error'
              });
            }
          }}
        />
      )}

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuggestionActions);
